import { createAsyncThunk } from '@reduxjs/toolkit'

import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../application/application-slice'
// controller code
import { PlayerRole } from '../../models'

export type AddPlayerRoleArg = {
  playerId: string
  playerRoleId: string
}

export type RemovePlayerRoleArg = {
  playerRoleId: string
  playerId: string
}

export type GetPlayerRolesForPlayerArg = {
  playerId: string
}

export type DeletePlayerRoleArg = {
  playerRoleId: string
}

export type CreateUpdatePlayerRoleArg = {
  playerRole: PlayerRole
}

export type GetPlayerRolesArg = {}

export type GetPlayerRoleByIdArg = {
  playerRoleId: string
}

export const AddPlayerRoleAsync = createAsyncThunk<any, AddPlayerRoleArg, any>(
  'composer/playerRolesController/add/player/role',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerRolesController/add/player/role'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const RemovePlayerRoleAsync = createAsyncThunk<
  any,
  RemovePlayerRoleArg,
  any
>(
  'composer/playerRolesController/remove/player/role',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerRolesController/remove/player/role'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const GetPlayerRolesForPlayerAsync = createAsyncThunk<
  any,
  GetPlayerRolesForPlayerArg,
  any
>(
  'composer/playerRolesController/get/player/roles/for/player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerRolesController/get/player/roles/for/player'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const DeletePlayerRoleAsync = createAsyncThunk<
  any,
  DeletePlayerRoleArg,
  any
>(
  'composer/playerRolesController/delete/player/role',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerRolesController/delete/player/role'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const CreateUpdatePlayerRoleAsync = createAsyncThunk<
  any,
  CreateUpdatePlayerRoleArg,
  any
>(
  'composer/playerRolesController/create/update/player/role',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerRolesController/create/update/player/role'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const GetPlayerRolesAsync = createAsyncThunk<
  any,
  GetPlayerRolesArg,
  any
>(
  'composer/playerRolesController/get/player/roles',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerRolesController/get/player/roles'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const GetPlayerRoleByIdAsync = createAsyncThunk<
  any,
  GetPlayerRoleByIdArg,
  any
>(
  'composer/playerRolesController/get/player/role/by/id',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerRolesController/get/player/role/by/id'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
